var React = require('react');

function Highlights (props) {
    return React.createElement("svg",props,React.createElement("polygon",{"points":"9.23 1 11.18 7 17.49 7 12.39 10.71 14.33 16.7 9.23 12.99 4.13 16.7 6.08 10.71 0.98 7 7.29 7 9.23 1","fill":"#1e80eb"}));
}

Highlights.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 18 18"};

module.exports = Highlights;

Highlights.default = Highlights;
